import React from 'react';
import variables from '../../styles/variables.module.scss';

interface FilterIconProps {
  inverse?: boolean;
}

const FilterIcon: React.FC<FilterIconProps> = ({ inverse }) => {
  const baseColor = inverse ? variables.greyLighter : variables.endeavour;
  const backgroundColor = inverse ? variables.endeavour : variables.greyLighter;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17">
      <g id="Group_6766" data-name="Group 6766" transform="translate(-1521 -488)">
        <rect
          id="Rectangle_4021"
          data-name="Rectangle 4021"
          width="17"
          height="1"
          rx="0.5"
          transform="translate(1521 490)"
          fill={baseColor}
        />
        <rect
          id="Rectangle_4022"
          data-name="Rectangle 4022"
          width="17"
          height="1"
          rx="0.5"
          transform="translate(1521 496)"
          fill={baseColor}
        />
        <rect
          id="Rectangle_4023"
          data-name="Rectangle 4023"
          width="17"
          height="1"
          rx="0.5"
          transform="translate(1521 502)"
          fill={baseColor}
        />
        <circle
          id="Ellipse_178"
          data-name="Ellipse 178"
          cx="2.5"
          cy="2.5"
          r="2.5"
          transform="translate(1523 494)"
          fill={baseColor}
        />
        <circle
          id="Ellipse_179"
          data-name="Ellipse 179"
          cx="1.5"
          cy="1.5"
          r="1.5"
          transform="translate(1524 495)"
          fill={backgroundColor}
        />
        <circle
          id="Ellipse_180"
          data-name="Ellipse 180"
          cx="2.5"
          cy="2.5"
          r="2.5"
          transform="translate(1527 488)"
          fill={baseColor}
        />
        <circle
          id="Ellipse_181"
          data-name="Ellipse 181"
          cx="1.5"
          cy="1.5"
          r="1.5"
          transform="translate(1528 489)"
          fill={backgroundColor}
        />
        <circle
          id="Ellipse_182"
          data-name="Ellipse 182"
          cx="2.5"
          cy="2.5"
          r="2.5"
          transform="translate(1525 500)"
          fill={baseColor}
        />
        <circle
          id="Ellipse_183"
          data-name="Ellipse 183"
          cx="1.5"
          cy="1.5"
          r="1.5"
          transform="translate(1526 501)"
          fill="#f2f2f2"
        />
      </g>
    </svg>
  );
};

export default FilterIcon;
